import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function Checkbox(props) {
  var value = props.value,
    label = props.label,
    required = props.required,
    disabled = props.disabled,
    defaultChecked = props.defaultChecked,
    onCheck = props.onCheck,
    showError = props.showError,
    errorMessage = props.errorMessage,
    isChecked = props.isChecked;
  function handleOnClick() {
    if (!disabled) {
      onCheck(value, !isChecked);
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-checkbox-wrapper ".concat(disabled ? 'bf-checkbox-is-disabled' : '', " ").concat(showError ? 'bf-checkbox-has-error' : '')
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: value,
    onClick: handleOnClick
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    value: value,
    required: required,
    disabled: disabled,
    checked: isChecked || defaultChecked,
    readOnly: true
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-checkbox-label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-checkbox-label-text"
  }, label), required ? /*#__PURE__*/React__default.createElement("span", {
    className: "bf-form-element-required-asterisk"
  }, " *") : null))), showError && errorMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-error-message"
  }, errorMessage) : null);
}
Checkbox.defaultProps = {
  isChecked: false,
  defaultChecked: false,
  required: false,
  onCheck: function onCheck() {},
  disabled: false,
  label: '',
  value: '',
  showError: false,
  errorMessage: ''
};
Checkbox.propTypes = {
  /**
  Checkbox can be checked by default
   */
  defaultChecked: PropTypes.bool,
  /**
  Function triggered when checkbox is clicked to be checked
   */
  onCheck: PropTypes.func,
  /**
  Set as required to be checked
   */
  required: PropTypes.bool,
  /**
  Checkbox can have disabled state
   */
  disabled: PropTypes.bool,
  /**
  Checkbox value attr
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
  Checkbox label text
   */
  label: nodeOrStringProp,
  /**
  Checkbox error status
   */
  showError: PropTypes.bool,
  /**
  Checkbox error status
   */
  errorMessage: nodeOrStringProp,
  /**
  Checkbox status
   */
  isChecked: PropTypes.bool
};

export default Checkbox;
